
import Fly from "flyio/dist/npm/fly";
import UAParser from "ua-parser-js";
import { $config } from "../conf";

/**
 * 错误报警
 * @param title 页面名称
 * @param method 方法名称
 * @param method_remark 方法描述
 * @param logs 日志信息
 * [
 *   {
 *     msg: "日志描述",
 *     json: data,
 *   },
 * ]
 */
function recordLog({ title, method, method_remark, logs }) {
  const Parser = UAParser();
  let logs_text = "",
    userInfo = {
      name: "",
      phone: "",
      email: "",
      sess: "",
    };
  logs.forEach((log) => {
    logs_text += `##### ${log.msg}：${JSON.stringify(log.json)}\n\n`;
  });

  let markText =
    `#### 异常页面：${title}\n\n` +
    `#### 异常方法：${method}---${method_remark}\n\n` +
    `#### 错误日志：\n\n` +
    `${logs_text}` +
    `> 用户名称：${userInfo.name}\n\n` +
    `> 手机号：${userInfo.phone}\n\n` +
    `> 邮箱：${userInfo.email}\n\n` +
    `> 用户标识：${userInfo.sess}\n\n` +
    `> 环境配置:\n\n` +
    `> 系统信息：${Parser.os.name}---${Parser.os.version}\n\n` +
    `> 浏览器信息：${Parser.browser.name}---${Parser.browser.version}\n\n` +
    `> 内核信息：${Parser.engine.name}---${Parser.engine.version}`;

  console.warn("报警信息", markText);

  if (!$config.warningLog.accessToken) {
    return;
  }
  new Fly().post(
    `https://oapi.dingtalk.com/robot/send?access_token=${$config.warningLog.accessToken}`,
    {
      msgtype: "markdown",
      markdown: {
        title: $config.warningLog.title,
        text: markText,
      },
      at: {
        isAtAll: true,
      },
    }
  );
}

class API {
  constructor(options) {
    this.fly = new Fly();
    Object.assign(this.fly.config, {
      baseURL: $config.api.gateway.general,
      headers: {
        "Content-Type": "text/plain",
      },
      method: "post",
      ...options,
    });
  }

  request(apiPath, params, options) {
    return this.fly
      .request(apiPath, params, options)
      .catch((data) => {
        if (data.status === 401) {
        }
        recordLog({
          title: window.location.href,
          method: "request",
          method_remark: "接口返回错误",
          logs: [
            {
              msg: apiPath + "入参",
              json: params,
            },
            {
              msg: apiPath + "响应",
              json: data,
            },
          ],
        });
        return Promise.reject({
          errorType: "interface_failed",
          ...data,
        });
      })
      .then((data) => {
        if(data.data.code===0){
          return Promise.resolve({
            ...data.data,
          });
        }
        if (data.data.body.result === 0) {
          return Promise.resolve({
            ...data.data.body,
          });
        }
        if (data.data.body.result != $config.warningLog.ignoreList[apiPath]) {
          recordLog({
            title: window.location.href,
            method: "request",
            method_remark: "接口调用失败",
            logs: [
              {
                msg: apiPath + "入参",
                json: params,
              },
              {
                msg: apiPath + "响应",
                json: data.data.body,
              },
            ],
          });
        }
        return Promise.reject({
          errorType: "interface_wrong",
          ...data.data.body,
        });
      });
  }
}

const api = new API();
const staticApi = new API({
  baseURL: $config.api.gateway.JsonUrl,
  method: "get",
});
export { recordLog, API, api, staticApi };
